import { Routes, RouterModule } from '@angular/router';
// import {NotFound} from './not-found';
import { AuthenticatedGuard } from './shared/guards/authenticated.guard';
import { NgModule } from '@angular/core';
import { HomeComponent } from './home/home.component';
import { CompanyComponent } from './company/company.component';
import { AutoEnrolComponent } from './auto_enrol/auto-enrol.component';
// import {LandingPageComponent} from './landing-page/landing-page.component';
// import {Home} from './home/home.component';
// import {Members} from './members/members.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'home',
    pathMatch: 'prefix',
    component: HomeComponent,
    canActivate: [AuthenticatedGuard]
  },
  {
    path: 'login',
    pathMatch: 'prefix',
    //component: LoginComponent
    //canActivate: [UnauthenticatedGuard]
    loadChildren: 'app/login/login.module'
  },
  
  {
    path: 'about',
    pathMatch: 'prefix',
    loadChildren: 'app/about/about.module',
  },
  {
    path: 'newsdetails',
    pathMatch: 'prefix',
    loadChildren: 'app/news-details/news-details.module'
  },
  {
    path: 'newslist',
    pathMatch: 'prefix',
    loadChildren: 'app/news-list/news-list.module'
  },
  //
  //   {
  //     path: 'productdirectory',
  //     pathMatch: 'prefix',
  //   //  loadChildren: 'app/product-directory/product-directory.module'
  //   },
  //   {
  //     path: 'productlist',
  //     pathMatch: 'full',
  //    // loadChildren: 'app/product-list/product-list.module'
  //   },
  //   {
  //     path: 'productdetail',
  //     pathMatch: 'full',
  //   //  loadChildren: 'app/product-details/product-details.module'
  //   },
  //   {
  //     path: 'patientinformation',
  //     pathMatch: 'prefix',
  //   //  loadChildren: 'app/patient-information/patient-information.module'
  //   },
  //   {
  //     path: 'patientinformationlist',
  //     pathMatch: 'prefix',
  //  //   loadChildren: 'app/patient-information-list/patient-information-list.module'
  //   },
  //   {
  //     path: 'patientinformationdetails',
  //     pathMatch: 'prefix',
  //   //  loadChildren: 'app/patient-information-details/patient-information-details.module'
  //   },
  //   {
  //     path: 'searchresults',
  //     pathMatch: 'full',
  //  //   loadChildren: 'app/search-results/search-results.module'
  //   },
  //   {
  //     path: 'interactions',
  //     pathMatch: 'prefix',
  //  //   loadChildren: 'app/interactions/interactions.module'
  //   },
  //   {
  //     path: 'research',
  //     pathMatch: 'prefix',
  // //    loadChildren: 'app/research/research-db.module'
  //   },
  //   {
  //     path: 'researchdblist',
  //     pathMatch: 'prefix',
  //  //   loadChildren: 'app/research-list/research-db-list.module'
  //   },
  //   {
  //     path: 'researchdbdetails',
  //     pathMatch: 'prefix',
  //  //   loadChildren: 'app/research-details/research-db-details.module'
  //   },
  //   {
  //     path: 'privacy',
  //     pathMatch: 'prefix',
  //  //   loadChildren: 'app/privacy/privacy.module',
  //   },
  //   {
  //     path: 'disclaimer',
  //     pathMatch: 'prefix',
  //  //   loadChildren: 'app/disclaimer/disclaimer.module',
  //   },
  //   {
  //     path: 'contactus',
  //     pathMatch: 'prefix',
  //   //  loadChildren: 'app/contact-us/contact-us.module'
  //   },
  //   {
  //     path: 'accessDenied',
  //     pathMatch: 'prefix',
  //  //   loadChildren: 'app/access-denied/access-denied.module'
  //   },
  //   {
  //     path: '404',
  //     pathMatch: 'prefix',
  //    // component: NotFound
  //   },
  //   {
  //     path: '**',
  //     pathMatch: 'prefix',
  //     redirectTo: '404'
  //   },
  {
    path: 'dashboard',
    pathMatch: 'full',
    loadChildren: 'app/dashboard/dashboard.module'
  },
  {
    path: 'staff-account',
    pathMatch: 'full',
    loadChildren: 'app/client-console/staff-account/staff-account.module'
  }, {
    path: 'staff-account-add',
    pathMatch: 'full',
    loadChildren: 'app/client-console/staff-account-add/staff-account-add.module'
  },
  {
    path: 'territory-list',
    pathMatch: 'full',
    loadChildren: 'app/client-console/territory/territory.module'
  },
  {
    path: 'territory-edit',
    pathMatch: 'full',
    loadChildren: 'app/client-console/territory-edit/territory-edit.module'
  },
  {
    path: 'modules-list',
    pathMatch: 'full',
    loadChildren: 'app/client-console/modules-list/modules-list.module'
  },
  {
    path: 'education-status-summary',
    pathMatch: 'full',
    loadChildren: 'app/client-console/education-reports/education-status-summary/education-status-summary.module'
  },
  {
    path: 'education-by-territory',
    pathMatch: 'full',
    loadChildren: 'app/client-console/education-reports/education-by-territory/education-by-territory.module'
  },
  {
    path: 'education-by-state',
    pathMatch: 'full',
    loadChildren: 'app/client-console/education-reports/education-by-state/education-by-state.module'
  },
  {
    path: 'education-by-banner',
    pathMatch: 'full',
    loadChildren: 'app/client-console/education-reports/education-by-banner/education-by-banner.module'
  },
  {
    path: 'education-by-profession',
    pathMatch: 'full',
    loadChildren: 'app/client-console/education-reports/education-by-profession/education-by-profession.module'
  },
  {
    path: 'client-console',
    pathMatch: 'full',
    loadChildren: 'app/client-console/client-console.module'
  },
  {
    path: 'trainingbystate',
    pathMatch: 'full',
    loadChildren: 'app/dashboard/trainingbystate.module'
  }
  ,
  {
    path: 'summarybystore',
    pathMatch: 'full',
    loadChildren: 'app/dashboard/summaryByStore.module'
  },
  {
    path: 'summarybymember',
    pathMatch: 'full',
    loadChildren: 'app/dashboard/summaryByMember.module'
  },
  {
    path: 'educationmodules',
    pathMatch: 'prefix',
    loadChildren: 'app/education-modules/education-modules.module',
    canActivate: [AuthenticatedGuard]
  },
  {
    path: 'updatepassword',
    pathMatch: 'prefix',
    loadChildren: 'app/update-password/update-password.module',
  },
  {
    path: 'referacolleague',
    pathMatch: 'prefix',
    loadChildren: 'app/refer-a-colleague/refer-a-colleague.module',
  },

  {
    path: 'join',
    pathMatch: 'prefix',
    loadChildren: 'app/join/join.module',
  },
  {
    path: 'competitions',
    pathMatch: 'prefix',
    loadChildren: 'app/competition/competition.module',
  },
  {
    path: 'categorylist',
    pathMatch: 'prefix',
    loadChildren: 'app/category-list/category-list.module#CategoriesListModule',
  },
  {
    path: 'brandslist',
    pathMatch: 'prefix',
    loadChildren: 'app/brands-list/brands-list.module',
  },
  {
    path: 'managerconsole',
    pathMatch: 'prefix',
    loadChildren: 'app/manager-console/manager-console.module',
  },
  {
    path: 'enroltomodule',
    pathMatch: 'prefix',
    loadChildren: 'app/enrol-to-module/enrol-to-module.module',
  },
  {
    path: 'myaccount',
    pathMatch: 'prefix',
    loadChildren: 'app/my-account/my-account.module',
  },
  {
    path: 'editaccountdetails',
    pathMatch: 'prefix',
    loadChildren: 'app/my-account-edit-details/edit-details.module',
  },
  {
    path: 'irewards',
    pathMatch: 'prefix',
    loadChildren: 'app/irewards/irewards.module',
  },
  {
    path: 'storelist',
    pathMatch: 'full',
    loadChildren: 'app/store/store-list.module'
  },
  {
    path: 'storemember',
    pathMatch: 'full',
    loadChildren: 'app/store-member/store-member.module'
  },
  {
    path: 'trainingplan',
    pathMatch: 'full',
    loadChildren: 'app/training-plan/training-plan.module'
  },
  {
    path: 'trainingplanadd',
    pathMatch: 'full',
    loadChildren: 'app/training-plan-add/training-plan-add.module'
  },
  {
    path: 'trainingplanedit',
    pathMatch: 'full',
    loadChildren: 'app/training-plan-add/training-plan-add.module'
  },
  {
    path: 'trainingplanmember',
    pathMatch: 'full',
    loadChildren: 'app/training-plan-member/training-plan-member.module'
  },
  {
    path: 'newaccounts',
    pathMatch: 'full',
    loadChildren: 'app/store-member-add/store-member-add.module'
  },
  {
    path: 'faq',
    pathMatch: 'prefix',
    loadChildren: 'app/faq/faq.module',
  },
  {
    path: 'privacy',
    pathMatch: 'prefix',
    loadChildren: 'app/privacy/privacy.module',
  },
  {
    path: 'disclaimer',
    pathMatch: 'prefix',
    loadChildren: 'app/disclaimer/disclaimer.module',
  },
  {
    path: 'contactus',
    pathMatch: 'prefix',
    loadChildren: 'app/contact-us/contact-us.module'
  },
  {
    path: 'suppliers',
    pathMatch: 'prefix',
    loadChildren: 'app/suppliers/suppliers.module'
  },
  {
    path: 'passReminder',
    pathMatch: 'prefix',
    loadChildren: 'app/forget-password/forget-password.module'
  },
  {
    path: 'search',
    pathMatch: 'prefix',
    loadChildren: 'app/search/search.module'
  },
  {
    path: 'login',
    pathMatch: 'prefix',
    loadChildren: 'app/landing-page/landing-page.module#LandingPageModule'
  },
  {
    path: 'login',
    pathMatch: 'prefix',
    loadChildren: 'app/learning-plans/learning-plans.module#LearningPlansModule'
  },
  {
    path: 'learningplanmodules',
    pathMatch: 'prefix',
    loadChildren: 'app/learning-plans-modules/learning-plans-modules.module#LearningPlansModulesModule'
  },
  {
    path: 'dashtrainingplan',
    pathMatch: 'full',
    loadChildren: 'app/dashboard-training-plan/dashboard-training-plan.module'
  },
  {
    path: 'dashtrainingplanadd',
    pathMatch: 'full',
    loadChildren: 'app/dashboard-training-plan-add/dashboard-training-plan-add.module'
  },
  {
    path: 'dashmanagerconsole',
    pathMatch: 'prefix',
    loadChildren: 'app/dashboard-manager-console/dashboard-manager-console.module',
  },
  {
    path: 'updateaccountdetails',
    pathMatch: 'prefix',
    loadChildren: 'app/login-update-details/login-update-details.module',
  },
  {
    path: 'learningplanadd',
    pathMatch: 'prefix',
    loadChildren: 'app/learning-plan-add/learning-plan-add.module',
  },
  {
    path: 'gxhregionalmanager',
    pathMatch: 'prefix',
    loadChildren: 'app/dashboard-gxh-regional-manager/dashboard-gxh-regional-manager.module',
  },
  {
    path: 'gxhregionalmanager/bycoursesummary',
    pathMatch: 'prefix',
    loadChildren: 'app/dashboard-gxh-regional-manager/by-course-summary/by-course-summary.module'
  },
  {
    path: 'gxhregionalmanager/bycourseuserdetails',
    pathMatch: 'prefix',
    loadChildren: 'app/dashboard-gxh-regional-manager/by-course-user-details/by-course-user-details.module',
  },
  {
    path: 'gxhregionalmanager/bylearningplansummary',
    pathMatch: 'prefix',
    loadChildren: 'app/dashboard-gxh-regional-manager/by-learningplan-summary/by-learningplan-summary.module',
  },
  {
    path: 'gxhregionalmanager/bycompetencysummary',
    pathMatch: 'prefix',
    loadChildren: 'app/dashboard-gxh-regional-manager/by-competency-summary/by-competency-summary.module',
  },
  {
    path: 'gxhregionalmanager/bylearningplanuserdetails',
    pathMatch: 'prefix',
    loadChildren: 'app/dashboard-gxh-regional-manager/by-learningplan-user-details/by-learningplan-user-details.module'
  },
  {
    path: 'gxhregionalmanager/bymodulesmain',
    pathMatch: 'prefix',
    loadChildren: 'app/dashboard-gxh-regional-manager/by-module-main-page/by-module-main-page.module'
  },
  {
    path: 'gxhregionalmanager/bymodulessummary',
    pathMatch: 'prefix',
    loadChildren: 'app/dashboard-gxh-regional-manager/by-modules-summary/by-modules-summary.module'
  },
  {
    path: 'gxhregionalmanager/bymodulesuserdetails',
    pathMatch: 'prefix',
    loadChildren: 'app/dashboard-gxh-regional-manager/by-modules-user-details/by-modules-user-details.module'
  },
  {
    path: 'gxhregionalmanager/bystorelist',
    pathMatch: 'prefix',
    loadChildren: 'app/dashboard-gxh-regional-manager/by-list-stores-reg-man/by-list-stores-reg-man.module'
  },
  {
    path: 'fastfactdirectory',
    pathMatch: 'prefix',
    loadChildren: 'app/fast-fact-directory/fast-fact-directory.module'
  },
  {
    path: 'fastfactdirectory/productlist',
    pathMatch: 'prefix',
    loadChildren: 'app/fast-fact-directory/product-list/product-list.module'
  },
  {
    path: 'fastfactdirectory/productdetail',
    pathMatch: 'prefix',
    loadChildren: 'app/fast-fact-directory/product-details/product-details.module'
  },
  {
    path: 'external-certificates',
    pathMatch: 'prefix',
    loadChildren: 'app/external-certificates/external-certificates.module',
    canActivate: [AuthenticatedGuard]
  },
  {
    path: 'quick-guides',
    pathMatch: 'prefix',
    loadChildren: 'app/quick-guides/quick-guides.module',
    canActivate: [AuthenticatedGuard]
  },
  {
    path: 'competency',
    pathMatch: 'prefix',
    loadChildren: 'app/competency/competency.module',
    canActivate: [AuthenticatedGuard]
  },
  {
    path: 'auto-enrol',
    component: AutoEnrolComponent
  },
  {
    path: '**',
    component: CompanyComponent
  }
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts